/* Helpers de navigation — Factumis app. */

/* Sanitise un paramètre de redirection (?next=…) : seuls les chemins internes
   (commençant par '/' mais pas '//') sont acceptés, pour éviter les
   redirections ouvertes vers des domaines externes. */
export function safeNext(raw: string | null, fallback = '/dashboard'): string {
  return raw && raw.startsWith('/') && !raw.startsWith('//') && !raw.startsWith('/\\') ? raw : fallback;
}
